import { createApi } from '@reduxjs/toolkit/query/react';
import rtkFetchRequest from '../configs/rtkFetchRequest';

// Define a service using a base URL and expected endpoints
export const customerApi = createApi({
  reducerPath: 'customers',
  baseQuery: rtkFetchRequest(),
  endpoints: (builder) => ({
    getCustomer: builder.query({
      query: () => ({
        method: 'GET',
        endpoint: `/users/me`,
      }),
    }),
    updateCustomer: builder.mutation({
      query: (params = {}) => ({
        method: 'PATCH',
        endpoint: `/users/me`,
        body: params,
      }),
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            customerApi.util.updateQueryData(
              'getCustomer',
              undefined,
              (draft) => {
                Object.assign(draft, data);
              },
            ),
          );
        } catch (error) {
          return error;
        }
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCustomerQuery, useUpdateCustomerMutation } = customerApi;
